import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { TopNav } from './SiteChrome';
import { useLanguage } from './LanguageContext';

const Home = () => {
  const { content } = useLanguage();

  return (
    <div className="home-page">
      {/* Ambient Background Effects */}
      <div className="home-ambient-bg">
        <div className="home-gradient-bg"></div>
        <div className="home-glow-tr"></div>
        <div className="home-glow-bl"></div>
        <div className="home-particle-bg"></div>
      </div>

      <TopNav />

      {/* Hero Section */}
      <main className="hero-main">
        {/* Central Visual Element (Cosmic Beam/Star) */}
        <div className="hero-visual">
          <div className="hero-beam-1"></div>
          <div className="hero-beam-2"></div>
          <div className="hero-star-core"></div>
        </div>

        <div className="hero-container">
          {/* Content Asymmetry: Offset to left */}
          <div className="hero-content-wrapper">
            {/* Decorative Layering behind text */}
            <div className="hero-text-bg-glow"></div>

            <div className="hero-text-block">
              <h1 className="hero-title">
                {content.home.title}
              </h1>
              <p className="hero-subtitle">
                {content.home.subtitle}
              </p>
            </div>

            <div className="hero-actions">
              <Link to="/contact" className="btn-primary group" style={{textDecoration: 'none'}}>
                {content.home.primary}
                <span className="material-symbols-outlined icon">arrow_forward</span>
              </Link>
              <Link to="/about" className="btn-secondary group" style={{textDecoration: 'none'}}>
                <span className="material-symbols-outlined icon">play_circle</span>
                {content.home.secondary}
              </Link>
            </div>

            {/* Instrumentation/Metadata tags */}
            <div className="hero-tags">
              <div className="hero-tag">
                <div className="tag-dot"></div>
                {content.home.tagOne}
              </div>
              <div className="hero-tag">
                <span className="material-symbols-outlined tag-icon">public</span>
                {content.home.tagTwo}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
